import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) {}

  getHome(){
    return this.http.get(environment.apiUrl + 'admin/home/show?lang=ge');
  }

  updatePositions(items: any[]) {
    return this.http.post(environment.apiUrl +  'admin/home/update-positions', items);
  }

  add(data: any) {
    return this.http.post(environment.apiUrl +  'admin/home/add', data);
  }

  update(data: any) {
    return this.http.post(environment.apiUrl +  'admin/home/update' ,data);
  }

  delete(id: number) {
    return this.http.delete(environment.apiUrl +  `admin/home/destroy/${id}`);
  }


}
